import { FirebaseApp, initializeApp } from "firebase/app";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyC6o-BLo38GB6GiXhv3T6HlJNe7rjqpvho",
  authDomain: "mela-1b60f.firebaseapp.com",
  databaseURL: "https://mela-1b60f.firebaseio.com",
  projectId: "mela-1b60f",
  storageBucket: "mela-1b60f.appspot.com",
  messagingSenderId: "1024275972734",
  appId: "1:1024275972734:web:519142c6dc0ce97f",
  measurementId: "G-SKXK4KGVN5",
};

const Firebase = () => {
  let app: FirebaseApp;

  const init = () => {
    if (app) {
      return app;
    }

    app = initializeApp(firebaseConfig);

    return app;
  };

  return {
    init,
    app,
  };
};

export default Firebase();
